import axios from '../../config/axiosConfig';
import { CREATE_BANK, GET_BANKS, BANK_REQUEST, DELETE_BANK, UPDATE_BANK, BANK_REQUEST_FAILURE, GET_BANKS_PAGE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getBanksWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
      return axios.get("/banks/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANKS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBanks = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
              }
            return axios.get('/banks/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANKS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createBank = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { banks } = getState();
            dispatch({ type: BANK_REQUEST });

            return axios.post('/banks/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_BANK, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getBanksWithPagination(
                            banks.page || 1,           // current page
                            banks.pageSize || 10,      // current page size
                            undefined,                  // include
                            banks.search || '',        // current search
                            undefined,                  // searchCols
                            banks.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('banks', response.data));
                    } else {
                        dispatch({ type: BANK_REQUEST_FAILURE, error: 'Bank create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBank = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { banks } = getState();
            dispatch({ type: BANK_REQUEST });
            return axios.put('/banks/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_BANK, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getBanksWithPagination(
                        banks.page || 1,           // current page
                        banks.pageSize || 10,      // current page size
                        undefined,                  // include
                        banks.search || '',        // current search
                        undefined,                  // searchCols
                        banks.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('banks', id, response.data));
                } else {
                    dispatch({ type: BANK_REQUEST_FAILURE, error: 'Bank update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteBank = (id) => {
    return async (dispatch, getState) => {
        try {
            const { banks } = getState();
            dispatch({ type: BANK_REQUEST });
            return axios.delete(`/banks/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_BANK, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getBanksWithPagination(
                        banks.page || 1,           // current page
                        banks.pageSize || 10,      // current page size
                        undefined,                  // include
                        banks.search || '',        // current search
                        undefined,                  // searchCols
                        banks.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('banks', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};